export const getActiveFilters = (t, filters, ns) => {
  if (!filters) {
    return {}
  }
  return Object.entries(filters).reduce(
    (acc, [key, value]) => ({
      ...acc,
      [t(`${ns}.Filter.${key.toUpperCase()}`)]:
        value === undefined
          ? []
          : key === 'catSeason_section'
          ? [value]
          : Object.entries(value)
              .filter(([_, enabled]) => enabled)
              .map(([filter]) => filter)
    }),
    {}
  )
}

export const getServerSideTableRequestBody = (request) => {
  const { startRow: start, sortModel, filterModel: filter, length } = request
  const body = {
    start,
    length,
    filter,
    sort: sortModel?.map(({ colId, sort }) => ({
      name: colId,
      direction: sort.toUpperCase()
    }))
  }

  return body
}

export const getFilterModelFromSelection = (selection) => {
  const { selectAll, excluded, included, count } = selection

  if (count === 0) {
    return {}
  }

  const filterBody = {
    filterType: 'set',
    type: selectAll ? 'notIn' : 'in',
    values: selectAll ? Object.keys(excluded) : Object.keys(included)
  }

  return { id: filterBody }
}
